export const VENEER_INVENTORY_REQUEST = "VENEER_INVENTORY_REQUEST";
export const VENEER_INVENTORY_SUCCESS = "VENEER_INVENTORY_SUCCESS";
export const VENEER_INVENTORY_FAILED = "VENEER_INVENTORY_FAILED";
export const VENEER_BULK_UPLOAD_DATA = "VENEER_BULK_UPLOAD_DATA";
export const VENEER_HISTORY_INVENTORY_REQUEST = "VENEER_HISTORY_INVENTORY_REQUEST";
export const VENEER_HISTORY_INVENTORY_SUCCESS = "VENEER_HISTORY_INVENTORY_SUCCESS";
export const VENEER_HISTORY_INVENTORY_FAILED = "VENEER_HISTORY_INVENTORY_FAILED";
